<template>
  <ModalComponent
    ref="component"
    :hashBase="hashBase"
    :keepContentAlive="keepContentAlive"
    class="[&_.w-screen>.flex.p-4]:!p-0 [&_.w-screen]:!overflow-hidden [&_.boxComponent]:!bg-transparent [&_.boxComponent]:!bg-none [&_.boxComponent]:![backdrop-filter:none] [&_.boxComponent]:!w-[100%] [&_.boxComponent]:!h-[100dvh] [&_.boxComponent]:!max-w-[100%] [&_.boxComponent]:!max-h-[100dvh] [&_.boxComponent]:!rounded-none [&_.boxComponent>div>div]:!p-0"
  >
    <template #header>
      <div></div>
    </template>
    <template #fullContent>
      <div
        class="fixed overflow-hidden h-[100svh] w-[100dvw] top-0 left-0 bg-white full-screen-modal-bg flex flex-col"
      >
        <div class="absolute top-4 right-4 z-10 full-screen-modal-close-button">
          <div
            class="cursor-pointer"
            @click="
              () => {
                $refs.component.hide()
              }
            "
          >
            <img
              src="@/assets/images/all/close-white.svg"
              class="w-[30px] h-[30px] cursor-pointer full-screen-modal-close-button-white hidden"
              alt=""
            />
            <img
              src="@/assets/images/all/close.svg"
              class="w-[30px] h-[30px] cursor-pointer full-screen-modal-close-button-black"
              alt=""
            />
          </div>
        </div>
        <slot></slot>
      </div>
    </template>
  </ModalComponent>
</template>

<script>
import { defineComponent } from 'vue'
import ModalComponent from './ModalComponent.vue'

export default defineComponent({
  name: 'ModalComponentFullScreen',
  components: { ModalComponent },
  props: {
    hashBase: {
      type: String,
      default: 'fullscreenmodal',
    },
    keepContentAlive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    show() {
      this.$refs.component.show()
    },
    hide() {
      this.$refs.component.hide()
    },
  },
  computed: {},
})
</script>
